export default {
  middleware_url: "https://lpsfrance.fluid-it.fr",
  cake_url: "https://lpsfrance.cake.fluid-it.fr",
  pwa_url: "https://app.lpsfrance.fluid-it.fr",
  isWavesoftEnabled: false,
  billingConforamaEnabled: false,
  isUrbantzEnabled: false,
  showLockBillingButton: true,
  useRatingSystem: true,
  useMapPage: true,
  useGpsTracking: true,
  instancePrefix: "28",
  googleMap: {
    api: "AIzaSyCNzBiL-zGLg5aVAXxIvvhXbe2NEquckUM",
  },
};
